import { render, staticRenderFns } from "./ShortlistNotification.vue?vue&type=template&id=c4acd070&scoped=true"
import script from "./ShortlistNotification.vue?vue&type=script&lang=js"
export * from "./ShortlistNotification.vue?vue&type=script&lang=js"
import style0 from "./ShortlistNotification.vue?vue&type=style&index=0&id=c4acd070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4acd070",
  null
  
)

export default component.exports